export const STORAGE_ENFORCEMENT_STATE_KEYS = {
	FLAGS_DISMISSED_FREE_THRESHOLD: 'storage-enforcement-state:flagsDismissedFreeThreshold',
} as const;

export const StorageEnforcementOnboardingKeys = [
	...Object.values(STORAGE_ENFORCEMENT_STATE_KEYS),
] as const;
